import { Injectable } from '@angular/core';
import { ToastProps } from '../models/toast.model';
import { PostMessageTypesEnum } from '../enums/post-message-types.enum';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  emitPropToParent<T, U>(key1: string, value1: T, key2?: string, value2?: U) {
    const message = {
      ...(key1 && { [key1]: value1 }),
      ...(key2 && { [key2]: value2 })
    };

    window.parent.postMessage(message, '*');
  }

  emitToast(toast: ToastProps) {
    this.emitPropToParent('type', PostMessageTypesEnum.TOAST, 'toast', toast);
  }
}
